import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { formatDateTime } from "../../components/formatDateTime";

function ViewSalesModal({ setViewModal, item, currency }) {
  function statusFormat(str) {
    if (!str) return str; // Handle empty string
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6   ">
        <div className="flex justify-end">
          <CancelIcon
            onClick={() => setViewModal(false)}
            className="cursor-pointer text-black mb-2"
          />
        </div>
        <div className=" flex flex-col gap-3 justify-center items-center">
          {/* for header */}
          <div className="flex flex-col text-center gap-3">
            <div>
              <h2>Order No:</h2>
              <h2 className="text-lg font-semibold">{item?.orderNO}</h2>
            </div>

            <div className="flex gap-2">
              <h4 className="">Customer Name: </h4>
              <h2 className="">{item?.customer?.name}</h2>
            </div>
            <div className="flex gap-2">
              <h4 className="">Cashier Name: </h4>
              <h2 className="">
                {item?.user?.firstname} {item?.user?.lastname}
              </h2>
            </div>
            <h2>{formatDateTime(item?.updated_at)}</h2>
          </div>

          {/* For order details */}
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="">
                <th className="py-2 px-4 border-b border-gray-300">Product</th>
                <th className="py-2 px-4 border-b border-gray-300">
                  Unit Price
                </th>
                <th className="py-2 px-4 border-b border-gray-300">Quantity</th>
                <th className="py-2 px-4 border-b border-gray-300">Total</th>
              </tr>
            </thead>
            <tbody>
              {item?.orderdetails?.map((order) => (
                <tr
                  key={order?.id}
                  className="hover:bg-gray-100 border-b border-gray-300"
                >
                  <td className="py-2 px-4 text-wrap text-center">
                    {order?.product_name}
                  </td>
                  <td className="py-2 px-4 text-wrap text-center">
                    {currency} {order?.unit_price}
                  </td>
                  <td className="py-2 px-4 text-wrap text-center">
                    {order?.quantity_ordered}
                  </td>
                  <td className="py-2 px-4 text-wrap text-center">
                    {currency}{" "}
                    {Number(order?.quantity_ordered) *
                      Number(order?.unit_price)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex item-center justify-center gap-3 ">
            <h4>{item?.bill_name} : </h4>
            <h4>{item?.auto_bill_total}</h4>
          </div>
          <div className="flex gap-2">
            <h4 className="">Total Price: </h4>
            <h2 className="font-semibold">
              {currency}
              {item?.total_price}
            </h2>
          </div>

          {/* <div className="flex flex-col">
            <div className="flex">
              <h3>Auto bill percentage: </h3>
              <h3>
                {item?.auto_bill_percentage
                  ? item?.auto_bill_percentage
                  : "N/A"}{" "}
              </h3>
            </div>
            <div className="flex gap-2">
              <h3>Auto bill total: </h3>
              <h3>{item?.auto_bill_total ? item?.auto_bill_total : "N/A"} </h3>
            </div>
          </div> */}
        </div>
        <div className="flex items-center mt-3 justify-center">
          <div
            className={`p-1 text-white rounded-md ${
              item?.status === "COMPLETED" ? "bg-green-500" : "bg-yellow-500"
            }`}
          >
            {statusFormat(item?.status)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewSalesModal;
